import factory from '../transactions/single-transaction/single-transaction-factory';

import merge from 'lodash/merge';

export default factory({
  assetCategory: 'loans',

  transactionFragmentExtend: {
    reference: true,
    type: true,
    amount: true,
    currency: true,
  },

  positionFragmentExtend: {
    maturityDate: true,
    maturityInterestPandIPosCcy: true,
  },

  mapper: data => {
    const { maturityDate, maturityInterestPandIPosCcy } = data.ui.positions.loans.currentPosition;
    const { currency } = data.ui.positions.loans.currentPosition.transactions[0];

    return merge(
      data,
      {
        ui: {
          positions: {
            loans: {
              currentPosition: {
                transactions: [{
                  amountUnit: currency,
                  maturityDate,
                  maturityInterestPandIPosCcy,
                  maturityInterestPandIPosCcyUnit: currency,
                }],
              },
            },
          },
        },
      }
    );
  },
});
